export default __webpack_public_path__ + "static/media/mixino.dda08234.glb";